import { render, staticRenderFns } from "./resume-educations-view.vue?vue&type=template&id=154c8823&scoped=true&"
import script from "./resume-educations-view.vue?vue&type=script&lang=js&"
export * from "./resume-educations-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c8823",
  null
  
)

export default component.exports